import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonDatetime,
  IonHeader,
  IonIcon,
  IonPopover,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';
import { DisplayService } from '@qid/core';
import { SuperButtonComponent } from '@qid/super';
import { MasterOrder } from '../../interface/master-order.interface';
import { OrderMasterApiService } from '../../services/order-master-api.service';
import { PaymentMethod } from '../../enum/payment-method.enum';
import { PaymentMethodSelectorComponent } from '../payment-method-selector/payment-method-selector.component';

export interface RecordPaymentResult {
  paymentDate: string;
  paymentMethod: string;
  referenceId: string;
}

@Component({
  selector: 'app-record-payment',
  templateUrl: './record-payment.component.html',
  styleUrls: ['./record-payment.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonContent,
    IonIcon,
    IonDatetime,
    IonPopover,
    SuperButtonComponent,
    PaymentMethodSelectorComponent,
  ],
})
export class RecordPaymentComponent {

  @Input() order!: MasterOrder;

  public readonly excludeMethods = [PaymentMethod.PAY_LATER, PaymentMethod.RAZORPAY_SUBSCRIPTION];

  public paymentDate = new Date().toISOString();
  public paymentMethod: PaymentMethod | null = null;
  public referenceId = '';
  public saving = false;

  constructor(
    private modalController: ModalController,
    private orderMasterApiService: OrderMasterApiService,
    private displayService: DisplayService,
  ) {
  }

  public get todayIso(): string {
    return new Date().toISOString();
  }

  close = async () => {
    await this.modalController.dismiss();
  };

  onPaymentDate(event: any) {
    this.paymentDate = event?.detail?.value || this.paymentDate;
  }

  submit = async () => {
    if (!this.order?._id) {
      return;
    }
    if (!this.paymentMethod) {
      await this.displayService.toast({ message: 'Select a payment method', color: 'warning' });
      return;
    }
    if (!this.referenceId?.trim()) {
      await this.displayService.toast({ message: 'Enter a reference ID', color: 'warning' });
      return;
    }

    this.saving = true;
    try {
      const body: RecordPaymentResult = {
        paymentDate: this.paymentDate,
        paymentMethod: this.paymentMethod,
        referenceId: this.referenceId.trim(),
      };
      const updated = await this.orderMasterApiService.recordPayment(this.order._id, body);
      await this.displayService.toast({ message: 'Payment recorded', color: 'success' });
      await this.modalController.dismiss({ recorded: true, order: updated });
    } catch {
      await this.displayService.toast({ message: 'Could not record payment', color: 'danger' });
    } finally {
      this.saving = false;
    }
  };
}
